import { ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Subject, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';

@Component({
    selector: 'app-user-management',
    templateUrl: './user-management.component.html',
    styleUrl: './user-management.component.css',
    standalone: false
})
export class UserManagementComponent implements OnChanges, OnInit {
  @Input() actionType: string = '';
  @Input() existingUser: any = [];
  @Input() TABLE_CONFIG: any = {};
  @Input() TABLE_COLUMNS: any = [];
  @Input() role: string = '';
  selectedAddUserslist: any = [];
  selectedRemoveUserlist: any = [];
  deletionUserList: any = [];
  statusUpdatedUsers: any = [];
  searchUserList: any = [];
  searchUser: any;
  dataSourceDetails: MatTableDataSource<any>;
  isTableRefreshed: boolean = false;
  @Output() getLatestChanges: EventEmitter<any> = new EventEmitter();
  subject = new Subject<string>();
  DATA_SCHEMA = {
    org_name: 'text',
    isEdit: 'isEdit'
  };
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc'
  };
  separatorKeysCodes: number[] = [ENTER];


  constructor(private toasterService: ToastrService, private capabilityService: CommonModelService, private elementRef: ElementRef) { }
  
  ngOnChanges(_changes: SimpleChanges): void {
    this.initialiaseData();//for every change in the input data, re-initialize the data
  }

  //set the initial data
  setInitialData() {
    this.selectedAddUserslist = [];
    this.selectedRemoveUserlist = [];
    this.deletionUserList = [];
    this.statusUpdatedUsers = [];
    this.searchUserList = [];
    this.searchUser = null;
  }

  ngOnInit(): void {
    this.initialiaseData();//for every change in the input data, re-initialize the data 
  }

  initialiaseData() {
    this.setInitialData();//set the initial data
    this.mapExistingUserForEdit();//Map the existing user data for edit
    this.setUpSubject();//Set up the subject for the search user 
  }

  mapExistingUserForEdit() {
    if (this.actionType == 'Edit' && this.existingUser.length > 0) {
      this.mapExistingUser();//Map the existing user data
    }
  }

  //Function to set up the subject for the search user
  setUpSubject() {
    this.subject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(() => this.getSearchedUser().pipe(
        catchError(_error => {
          this.toasterService.error('Failed to load LDAP users', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          return of([]);
        })
      ))
    ).subscribe((users) => {
      this.disableExistingUsers(users);
    },
      _error => {
        // Handle error scenario
        this.toasterService.error('Failed to load LDAP users', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      });
  }

  //Function to map the existing user data with msid and leadEA
  mapExistingUser() {
    this.existingUser.forEach(user => {
      user['MSId']=user.msid;
      if(user.leadEA == null){
        user['leadEA'] = 'No'; 
      }
    });
    const list = _.cloneDeep(this.existingUser);
    this.createDataSource(list);
  }

  //map the selected added user with leadEA and isNewUser
  mapSelectedAddedUser() {
    this.selectedAddUserslist.forEach((user: any) => {
      user['leadEA'] = 'No';
      user['isNewUser'] = true;
    });
  }

  //Function to add user into list 
  onAddUser() {
    this.mapSelectedAddedUser();
    if (this.actionType == 'Edit' && this.existingUser.length > 0) {
      this.selectedAddUserslist = this.replaceDataForExistingtUser(this.existingUser, this.selectedAddUserslist, 'mail');
    }
    const newList = this.dataSourceDetails?.data?.length > 0 
        ? this.selectedAddUserslist.concat(this.dataSourceDetails.data) 
        : this.selectedAddUserslist;
    this.createDataSource(newList); //update the table
    this.clearDataForAddUser();
  }

  //Function to clear the data after adding the user
  clearDataForAddUser() {
    this.selectedAddUserslist = [];
    this.searchUserList = [];
    this.searchUser = null;
    this.isTableRefreshed = true;
    this.getUpdatedValues();
  }

  //Function to check if the new added user is already present in the existing list
  //If yes then replace the data with the existing data
  replaceDataForExistingtUser(arr1, arr2, key) {
    const replaceDataArray = [];
    arr2.forEach((item2) => {
      const item1 = arr1.find((item) => item[key] == item2[key]);
      if (item1) {
        this.deletionUserList = this.removeUserFromList(this.deletionUserList,item1,'mail');
        replaceDataArray.push(item1);
      }else{
        replaceDataArray.push(item2);
      }
    });
    return replaceDataArray;
  }

  //Function to remove user from the list
  removeUserFromList(arr1,obj, key) {
    return arr1.filter((item) => item[key] != obj[key]);
  }

  //Function to remove user from list 
  //Also checks if the user is already present in the list or a new user got deleted
  onRemoveUser() {
    const filterArray = this.filterArray(this.dataSourceDetails.data, this.selectedRemoveUserlist, 'mail');
    this.createDataSource(filterArray); //update the table
    this.getDeletedUsersList();//get the deleted users list
    this.selectedRemoveUserlist = [];
    this.isTableRefreshed = true;
  }

  //Function to get deleted Users list that are present in the existing list
  getDeletedUsersList() {
    const deletionUserList = this.selectedRemoveUserlist.filter((user: any) => !user.isNewUser);
    this.deletionUserList = this.deletionUserList.concat(deletionUserList);
    if(this.actionType == 'Edit'){
      this.statusUpdatedUsers = this.checkUserForLeadEA(this.statusUpdatedUsers, this.deletionUserList , 'mail');
    }
    this.getUpdatedValues();
  }

  //Function to check when the user is removed from the list then is the user lead status also updated
  //If yes then remove the user from the statusUpdatedUsers list
  checkUserForLeadEA(arr1, arr2, key) {
    arr2.forEach((item) => {
      const index = arr1.findIndex((user: any) => user[key] == item[key]);
      if (index > -1) {
        arr1.splice(index, 1);
      }
    });
    return arr1;
  }

  //Function to create data source for the table
  createDataSource(data) {
    this.dataSourceDetails = new MatTableDataSource(data);
  }

  //Function to handle checkbox click event
  checkboxClick(event) {
    this.selectedRemoveUserlist = event.data;
    if (this.isTableRefreshed) {
      this.isTableRefreshed = false;
    }
  }

  //Function to handle star event
  updateLeadStatus(event) {
    const data = this.dataSourceDetails.data.map((user: any) => {
      if (user.mail == event.mail) {
        user.leadEA = event.leadEA == 'Yes' ? 'No' : 'Yes';
      }
      return user;
    });
    this.isTableRefreshed = false;
    this.createDataSource(data); //update the table
    if (this.actionType == 'Edit') {
      if (!event.isNewUser) {
        if (this.checkExistingUserValue(event)) {
          this.statusUpdatedUsers = this.statusUpdatedUsers.filter((user: any) => user.mail != event.mail);
        } else {
          this.statusUpdatedUsers.push(event);
        }
      }
    }
    this.getUpdatedValues();
  }

  //Check if the user is already present in the existingUser list
  //If yes then no need to add the user in the statusUpdatedUsers list
  checkExistingUserValue(event) {
    let isUserPresent = false;
    const existingUser = this.existingUser.find((user: any) => user.mail == event.mail);
    if (existingUser && existingUser.leadEA == event.leadEA) {
      isUserPresent = true;
    }
    return isUserPresent;
  }

  //Function to filter the array based on the key
  filterArray(array1, array2, key1) {
    {
      const array2Ids = array2.map((item) => {
        return item[key1]
      });
      array1 = array1.filter(item => {
        if (!array2Ids.includes(item[key1])) {
          return item;
        }
      });

      return array1;
    }
  }

  //Function to pass the updated values to the parent component
  getUpdatedValues() {
    const updatedValues = {
      removeUsers: this.deletionUserList,
      statusUpdatedUsers: this.statusUpdatedUsers,
      addUsers: this.dataSourceDetails.data.filter((user: any) => user.isNewUser)
    }
    this.getLatestChanges.emit(updatedValues);
  }

  filterUsers(arr, key) {
    return arr.filter((user: any) => !user[key]);
  }

  // Load User data into the table
  public onSearchUser(ev) {
    this.searchUser = ev;
    if (this.searchUser.target.value.length >= 4) {
      this.subject.next(this.searchUser.target.value);
    }
  }

  // Get the searched user from the LDAP API
  getSearchedUser() {
    return this.capabilityService.getLDAPUsers(this.searchUser.target.value);
  }

  //disable already added users
  disableExistingUsers(dataStream: Array<any>) {
    let existingEmails = new Set();
    if (this.actionType == 'Edit' && this.existingUser.length > 0) {
      existingEmails = new Set(this.dataSourceDetails.data.map(user => user.mail));
    }
    dataStream.forEach(item => {
      // Disable the item if the email is undefined or already exists in the set
      if (item.mail == undefined || existingEmails.has(item.mail)) {
        item.disable = true;
      } else {
        item.disable = false;
      }
    });
    this.searchUserList = dataStream;
  }

  //Function to get the selected users
  //Also checks if the user is selected/deselected
  getSelectedUsers(event) {
    const userDatA = event.option.value;
    userDatA['MSId'] = userDatA['cn'];
    this.selectedAddUserslist.push(userDatA) ;
    this.searchUser.target.value = '';
    this.searchUserList = [];
    if(this.isTableRefreshed){
      this.isTableRefreshed = false;
    }
  }

  //check if the user is already present in the list
  //if yes the delete the user from the list
  removeSelectedUser(user) {
    const index = this.selectedAddUserslist.findIndex((item: any) => item.MSId == user.cn);
    if (index > -1) {
      this.selectedAddUserslist.splice(index, 1);
    }
    this.searchUserList = [];
  }

}
